import { urls } from '../urls';

export const serviceTeaserConfig = {
  documents: {
    description: 'Sehen Sie hier Ihre Reiseunterlagen ein',
    url: urls.documents,
    headline: 'Dokumente',
    iconClass: 'icon-documents',
    image: '/public/assets/images/teasers/documents.jpg',
  },
  payment: {
    url: urls.payment,
    description: 'Sehen Sie hier ihre Zahlungen ein',
    headline: 'Bezahlung',
    iconClass: 'icon-payment',
    image: '/public/assets/images/teasers/payment.jpg',
  },
};

export const serviceTeaserDisplayConfig = {
  rounded: 'rounded-xl',
  shadow: 'shadow-lg',
  overlay: true,
};

export const bookingTeaserConfig = {
  hotel: {
    headline: 'Unterkunft',
    iconClass: 'icon-hotel',
    image: '/public/assets/images/teasers/accomodation.jpg',
    url: urls.hotelDetails,
  },
  flight: {
    headline: 'Flug',
    iconClass: 'icon-flight-up',
    image: '/public/assets/images/teasers/flights.jpg',
    url: urls.flightDetails,
  },
  transfer: {
    description: 'Alle Infos zu Ihrem Transfer',
    url: urls.transfer,
    headline: 'Transfer',
    iconClass: 'icon-bus',
    image: '/public/assets/images/teasers/transfer.jpg',
  },
  noInsurance: {
    headline: 'Reiseversicherung',
    iconClass: 'icon-insurance',
    image: '/public/assets/images/teasers/insurance.jpg',
  },
};

export const bookingTeaserDisplayConfig = {
  overlay: true,
  rounded: 'rounded-lg',
  shadow: 'shadow-md',
  textSize: 'text-sm',
};

export const extrasTeaserConfig = [
  {
    headline: 'Zusatzleistungen',
    iconClass: 'icon-services',
    image: '/public/assets/images/teasers/upgrades.jpg',
    url: urls.upgrades,
  },
  {
    headline: 'Reiseversicherung',
    iconClass: 'icon-insurance',
    image: '/public/assets/images/teasers/insurance.jpg',
    url: urls.insurance,
  },
  {
    headline: 'Ausflüge',
    iconClass: 'icon-tickets',
    image: '/public/assets/images/teasers/activities.jpg',
    url: urls.excursions.index,
  },
  {
    headline: 'Mietwagen',
    iconClass: 'icon-car',
    image: '/public/assets/images/teasers/rental-car.jpg',
    url: urls.rentalCar,
  },
];

export const extrasTeaserDisplayConfig = {
  overlay: true,
  rounded: 'rounded-xl',
  shadow: 'shadow-lg',
  textSize: 'text-sm',
};
